import {lazy} from 'react';

export const TableLazy = lazy(() => import(/* webpackChunkName: "table" */ '.'));
